import { FocusMonitor } from '@angular/cdk/a11y';
import { Component, ElementRef, HostBinding, HostListener, Input, Optional, Self, ViewChild } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { MatFormFieldBaseComponent } from 'src/lib/mat-form-field.component';

@Component({
	selector: 'mat-file-input',
	templateUrl: './mat-file-input.component.html',
	styleUrls: ['./mat-file-input.component.scss'],
	providers: [{provide: MatFormFieldControl, useExisting: MatFileInputComponent}]
})
export class MatFileInputComponent extends MatFormFieldBaseComponent<File> {

	static nextId: number = 0;

	isDragging: boolean = false;

	@Input() @HostBinding() id = `mat-file-input-${MatFileInputComponent.nextId++}`;
	@ViewChild('fileInputElement') fileInputElementRef: ElementRef<HTMLInputElement>;

	@Input() placeholder: string = `Déposez ${ this.multiple ? 'des' : 'un' } fichier${ this.multiple ? 's' : '' } ou cliquez pour sélectionner`;
	@Input() accept: string = '';

	@HostListener('dragover', ['$event']) allowDrop(event) {
		event.stopPropagation();
		event.preventDefault();
		event.dataTransfer.dropEffect = 'copy';
		this.isDragging = true;
	}

	@HostListener('drop', ['$event']) onDrop(event) {
		event.stopPropagation();
		event.preventDefault();
		this.onSelectFiles(event.dataTransfer.files);
		this.isDragging = false;
	}

	@HostListener('dragleave') onDragLeave () { this.isDragging = false; }

	constructor(@Optional() @Self() public ngControl: NgControl,
				public focusMonitor: FocusMonitor,
				public elementRef: ElementRef<HTMLElement>) { super(ngControl, focusMonitor, elementRef) }

	onSelectFiles (files: FileList) {
		if(files.length) {

			const safeFiles = this.rename(Array.from(files));

			if(this._multiple)
				this.value = ((this.value ?? []) as File[]).concat(safeFiles).unique('name');
			else
				this.value = (safeFiles instanceof File ? safeFiles : safeFiles.first);
			
			this.onChange();
			this.fileInputElementRef.nativeElement.value = '';
		}
	}

	onDeselectFile (index: number) {

		if(this.multiple)
			(this.value as File[]).splice(index, 1);
		else
			this.value = null;

		this.onChange();
		this.fileInputElementRef.nativeElement.value = '';
	}

	onContainerClick(event: MouseEvent): void {
		this.fileInputElementRef.nativeElement.click();
		event.stopPropagation();
	}

	rename (files: File | File[]): File | File[] {

		if(Array.isArray(files))
			files.each((file, index) => {

				const existing = files.findIndex(({name}) => name == file.name);

				if(existing > -1 && existing !== index)
					files[index] = new File([file], file.name.replace(/(\.[a-z]+)$/i, `${index}$1`));
			});

		return files;
	}

	writeValue(files: File | File[]): void { 
		super.writeValue(this.rename(files));
	}
}